import { Component, effect, inject, input } from '@angular/core';
import { ProjectDataService } from '../../state-and-data-handling/project-data.service';
import { ProjectBudgetChartTransformerService } from '../services/project-budget-chart-transformer.service';
import { ProjectModel } from '../../../../../core/models/project/project.model';
import { LineChartData } from '../../../../../shared/data-types/chart-types';
import { Interval } from 'date-fns';
import { TimeBlockWithTask } from '../../../../../shared/data-types/shared-time-block-types';

@Component({
  selector: 'app-project-budget-chart',
  templateUrl: './project-budget-chart.component.html',
  standalone: false,
})
export class ProjectBudgetChartComponent {
  timeBlocksWithTask = input.required<readonly TimeBlockWithTask[]>();
  timeRange = input.required<Interval>();

  public data: LineChartData[] = [];

  private readonly projectDataService = inject(ProjectDataService);
  private readonly projectBudgetChartTransformerService = inject(
    ProjectBudgetChartTransformerService,
  );

  constructor() {
    // React to input changes
    effect(() => {
      const timeBlocksWithTask = this.timeBlocksWithTask();
      const timeRange = this.timeRange();

      if (timeBlocksWithTask && timeRange) {
        const project = this.projectDataService.getProjectClone();
        this.createSeriesData(project);
      }
    });
  }

  private createSeriesData(project: ProjectModel): void {
    this.data = this.projectBudgetChartTransformerService.transformFeesToChartData(
      project,
      this.timeRange().start as Date,
      this.timeRange().end as Date,
      this.timeBlocksWithTask(),
    );
  }
}
